import { checkSubscriptionResource } from 'common/subscription/checkSubscriptionResource';
import { checkIsUserJoined } from '../../common/checkRoleUser';
import { ROLE_ACCESS } from '../../constant/storage';
import {
  FolderStatusEnum,
  ICourseDetailResponse,
} from '../../interfaces/training.interface';
import useRoleAccess from '../my-group/useRoleAccess';
import useGetLatestSubscription from '../subscription/useGetLatestSubscription';
import { useFetchCourseDetails } from './useFetchCourseDetails';

const useCourseDetailPermission = (initialData?: ICourseDetailResponse) => {
  const { mineRole, roleQueryReturn } = useRoleAccess(
    initialData?.group?.id || null,
    ROLE_ACCESS.Viewer
  );

  const { data: latestSubscription } = useGetLatestSubscription({});

  const { queryReturn: courseDetailQueryReturn } = useFetchCourseDetails({
    initialData,
    refetchOnMount: 'always'
  });

  const isOwnerCourse =
    courseDetailQueryReturn.data?.isOwner || mineRole === ROLE_ACCESS.Owner; //owner course or owner group also means owner course

  const isHavePrice =
    !!courseDetailQueryReturn?.data?.coursePrice?.isPaidCourse; //a
  const isPaid = !!courseDetailQueryReturn?.data?.userOrder?.hasUserPaid; //b

  const isGroupPrivate =
    courseDetailQueryReturn.data?.group?.status === FolderStatusEnum.Private; //c

  const isJoined = checkIsUserJoined(mineRole) || isOwnerCourse; //d

  const fullyLock =
    (isHavePrice && !isPaid && !isJoined) || (isGroupPrivate && !isJoined);

  const fullAccess =
    checkSubscriptionResource(latestSubscription).course.accessToCourse ||
    (isHavePrice && isPaid && isJoined) ||
    (!isHavePrice && (!isGroupPrivate || isJoined)) ||
    isOwnerCourse;

  const eachLock = !fullAccess && !fullyLock;

  return {
    mineRole: isOwnerCourse ? ROLE_ACCESS.Owner : mineRole,
    roleQueryReturn,
    courseDetailQueryReturn,
    fullyLock,
    eachLock,
    fullAccess,
    latestSubscription,
  };
};

export default useCourseDetailPermission;
